<!-- ── Encabezado ───────────────────────────────────────────────────────── -->
<app-page-title [title]="pageLabel()" backRoute="/support/menu" backTooltip="Regresar al menú de Soporte"></app-page-title>
<app-page-loader [load]="pageLoad" [label]="pageLabel()" (retry)="init()"></app-page-loader>

<!-- ── Chips de conteo por estado (también filtran) ─────────────────────── -->
<div class="status-chips">
  <button class="chip chip-total"
          [class.chip-active]="statusFilter() === 'TODOS'"
          (click)="setStatusFilter('TODOS')">
    Todos <b>{{ counters().total }}</b>
  </button>
  <button class="chip chip-pendiente"
          [class.chip-active]="statusFilter() === 'PENDIENTE'"
          (click)="setStatusFilter('PENDIENTE')">
    Pendientes <b>{{ counters().pendiente }}</b>
  </button>
  <button class="chip chip-asignado"
          [class.chip-active]="statusFilter() === 'ASIGNADO'"
          (click)="setStatusFilter('ASIGNADO')">
    En proceso <b>{{ counters().asignado }}</b>
  </button>
  <button class="chip chip-solucionado"
          [class.chip-active]="statusFilter() === 'SOLUCIONADO'"
          (click)="setStatusFilter('SOLUCIONADO')">
    Solucionados <b>{{ counters().solucionado }}</b>
  </button>
</div>

<!-- ── Tabla ────────────────────────────────────────────────────────────── -->
<div class="table-section">

  <div class="filter-bar filter-bar--flush">
    <div class="filter-card">
      <app-search-pill [value]="filter()" placeholder="Folio, asunto, módulo, solicitante…" (search)="applyFilter($event)"></app-search-pill>
      <mat-button-toggle-group class="view-toggle" [value]="listView.mode" (change)="listView.set($event.value)" [hideSingleSelectionIndicator]="true" aria-label="Vista">
      <mat-button-toggle value="table" matTooltip="Vista de tabla"><mat-icon>table_rows</mat-icon></mat-button-toggle>
      <mat-button-toggle value="cards" matTooltip="Vista de tarjetas"><mat-icon>grid_view</mat-icon></mat-button-toggle>
    </mat-button-toggle-group>
    </div>
    <app-filter-chips [chips]="activeChips()" [count]="visibleTickets().length" [total]="tickets().length" noun="tickets" (remove)="setStatusFilter('TODOS')" (clear)="setStatusFilter('TODOS'); filter.set('')"></app-filter-chips>
  </div>

  <div class="list-actions">
    <button mat-stroked-button (click)="pageLoad.refresh(loadTickets())" [disabled]="loading()"><mat-icon>refresh</mat-icon> Actualizar
    </button>
    <button mat-flat-button color="primary" (click)="openCreate()">
      <mat-icon>add</mat-icon> Nuevo ticket
    </button>
  </div>

  <app-selection-bar [count]="sel.count" (export)="exportExcel(sel.selected)" (clear)="sel.clear()"></app-selection-bar>

  @if (loading()) {
    <div class="loading-row">
      <mat-spinner diameter="22"></mat-spinner>
      <span>Cargando tickets…</span>
    </div>
  }


  @if (listView.mode === 'cards') {
    <div class="inv-cards cat-cards">
      @for (ticket of visibleTickets(); track ticket.id) {
        <div class="cat-card" [class.cat-card--selected]="sel.isSelected(ticket)">
          <div class="cat-card__head">
            <mat-checkbox color="primary" [checked]="sel.isSelected(ticket)" (change)="sel.toggle(ticket)" matTooltip="Seleccionar"></mat-checkbox>
            <span class="cat-card__title"><span class="folio">{{ ticket.folio }}</span></span>
            <span class="status-badge" [class]="statusClass(ticket.status)">{{ statusLabel(ticket.status) }}</span>
          </div>
          <div class="cat-card__body">
            <div class="cat-card__field"><span class="cat-card__label">Asunto:</span><span class="cat-card__value">{{ ticket.subject }}</span></div>
            @if (ticket.location) {<div class="cat-card__field"><span class="cat-card__label">Ubicación:</span><span class="cat-card__value">{{ ticket.location }}</span></div>}
            <div class="cat-card__field"><span class="cat-card__label">Tipo:</span><span class="cat-card__value">{{ ticket.ticketType === 'HARDWARE' ? 'Hardware' : 'Software' }} · {{ ticket.module }}</span></div>
            @if (isAdmin()) {<div class="cat-card__field"><span class="cat-card__label">Solicitante:</span><span class="cat-card__value">{{ ticket.requestedByName || 'Sin nombre' }}</span></div>}
            <div class="cat-card__field"><span class="cat-card__label">Responsable:</span><span class="cat-card__value">{{ ticket.assignedToName || 'Sin asignar' }}</span></div>
            <div class="cat-card__field"><span class="cat-card__label">Creado:</span><span class="cat-card__value">{{ ticket.createdOn }}</span></div>
            <div class="cat-card__field"><span class="cat-card__label">Prioridad:</span><span class="cat-card__value"><span [class]="priorityClass(ticket)">{{ priorityName(ticket) }}</span></span></div>
            <div class="cat-card__field"><span class="cat-card__label">Tiempo estimado:</span><span class="cat-card__value">{{ (ticket.priority || ticket.estimatedHours != null) ? estimatedLabel(ticket) : 'Sin estimar' }}</span></div>
          </div>
          <div class="cat-card__actions">
          <button mat-icon-button matTooltip="Ver detalle" (click)="openDetail(ticket)"><mat-icon>visibility</mat-icon></button>
          @if (canEdit(ticket)) {
            <button mat-icon-button color="primary" matTooltip="Editar ticket" (click)="openEdit(ticket)"><mat-icon>edit</mat-icon></button>
          }
          @if (isAdmin()) {
            <button mat-icon-button color="primary" [matTooltip]="ticket.assignedToName ? 'Responsable: ' + ticket.assignedToName + ' (cambiar)' : 'Asignar responsable'" (click)="openAssign(ticket)"><mat-icon>{{ ticket.assignedTo ? 'manage_accounts' : 'person_add' }}</mat-icon></button>
            <button mat-icon-button color="accent" matTooltip="Acciones (prioridad, asignación y estado)" (click)="openActions(ticket)"><mat-icon>build</mat-icon></button>
            <button mat-icon-button [matMenuTriggerFor]="cardStatusMenu" matTooltip="Cambiar estado"><mat-icon>swap_horiz</mat-icon></button>
            <mat-menu #cardStatusMenu="matMenu">
              @for (status of statuses; track status.id) {
                <button mat-menu-item (click)="changeStatus(ticket, status.id)" [disabled]="ticket.status === status.id">{{ status.name }}</button>
              }
            </mat-menu>
            <button mat-icon-button color="warn" matTooltip="Eliminar" (click)="deleteTicket(ticket)"><mat-icon>delete</mat-icon></button>
          }
          </div>
        </div>
      }
      @if (visibleTickets().length === 0) {
        <p class="inv-cards__empty">{{ tickets().length === 0 ? 'Todavía no hay tickets. Levanta el primero con "Nuevo ticket".' : 'Ningún ticket coincide con el filtro.' }}</p>
      }
    </div>
  }

  <div class="table-container" [hidden]="listView.mode !== 'table'">
    <table mat-table [dataSource]="visibleTickets()">

      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef class="select-cell">
          <mat-checkbox color="primary" (change)="$event ? sel.toggleAll() : null" [checked]="sel.allSelected()" [indeterminate]="sel.someSelected()" matTooltip="Seleccionar todos los visibles"></mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let row" class="select-cell">
          <mat-checkbox color="primary" (click)="$event.stopPropagation()" (change)="$event ? sel.toggle(row) : null" [checked]="sel.isSelected(row)"></mat-checkbox>
        </td>
      </ng-container>
  

      <!-- Folio -->
      <ng-container matColumnDef="folio">
        <th mat-header-cell *matHeaderCellDef>Folio</th>
        <td mat-cell *matCellDef="let ticket"><span class="folio">{{ ticket.folio }}</span></td>
      </ng-container>

      <!-- Asunto -->
      <ng-container matColumnDef="subject">
        <th mat-header-cell *matHeaderCellDef>Asunto</th>
        <td mat-cell *matCellDef="let ticket">
          <div class="subject-cell">
            <span class="subject">{{ ticket.subject }}</span>
            @if (ticket.location) {
              <span class="location">{{ ticket.location }}</span>
            }
          </div>
        </td>
      </ng-container>

      <!-- Módulo -->
      <ng-container matColumnDef="module">
        <th mat-header-cell *matHeaderCellDef>Tipo · Módulo / herramienta</th>
        <td mat-cell *matCellDef="let ticket">
          <span class="ticket-type">{{ ticket.ticketType === 'HARDWARE' ? 'Hardware' : 'Software' }}</span>
          {{ ticket.module }}
        </td>
      </ng-container>

      <!-- Solicitante (solo admin) -->
      <ng-container matColumnDef="requestedByName">
        <th mat-header-cell *matHeaderCellDef>Solicitante</th>
        <td mat-cell *matCellDef="let ticket">
          {{ ticket.requestedByName || 'Sin nombre' }}
        </td>
      </ng-container>

      <!-- Fecha de creación -->
      <ng-container matColumnDef="createdOn">
        <th mat-header-cell *matHeaderCellDef>Creado</th>
        <td mat-cell *matCellDef="let ticket">{{ ticket.createdOn }}</td>
      </ng-container>

      <!-- Prioridad -->
      <ng-container matColumnDef="priority">
        <th mat-header-cell *matHeaderCellDef>Prioridad</th>
        <td mat-cell *matCellDef="let ticket"><span [class]="priorityClass(ticket)">{{ priorityName(ticket) }}</span></td>
      </ng-container>

      <!-- Tiempo estimado = tiempo de resolución de la prioridad -->
      <ng-container matColumnDef="estimatedHours">
        <th mat-header-cell *matHeaderCellDef>Tiempo estimado</th>
        <td mat-cell *matCellDef="let ticket">
          @if (ticket.priority || ticket.estimatedHours != null) {
            <span class="hours">{{ estimatedLabel(ticket) }}</span>
          } @else {
            <span class="no-data-inline">Sin estimar</span>
          }
        </td>
      </ng-container>

      <!-- Estado -->
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>Estado</th>
        <td mat-cell *matCellDef="let ticket">
          <span class="status-badge" [class]="statusClass(ticket.status)">
            {{ statusLabel(ticket.status) }}
          </span>
        </td>
      </ng-container>

      <!-- Acciones -->
      <ng-container matColumnDef="actions" stickyEnd>
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let ticket">
          <button mat-icon-button matTooltip="Ver detalle" (click)="openDetail(ticket)">
            <mat-icon>visibility</mat-icon>
          </button>

          <!-- Quien levantó el ticket lo puede editar mientras no esté solucionado. -->
          @if (canEdit(ticket)) {
            <button mat-icon-button color="primary" matTooltip="Editar ticket" (click)="openEdit(ticket)">
              <mat-icon>edit</mat-icon>
            </button>
          }

          <!-- Las acciones son exclusivas del Administrador Epione. -->
          @if (isAdmin()) {
            <button mat-icon-button color="primary" [matTooltip]="ticket.assignedToName ? 'Responsable: ' + ticket.assignedToName + ' (cambiar)' : 'Asignar responsable'"
                    (click)="openAssign(ticket)">
              <mat-icon>{{ ticket.assignedTo ? 'manage_accounts' : 'person_add' }}</mat-icon>
            </button>
            <button mat-icon-button color="accent" matTooltip="Acciones (prioridad, asignación y estado)"
                    (click)="openActions(ticket)">
              <mat-icon>build</mat-icon>
            </button>
            <button mat-icon-button [matMenuTriggerFor]="statusMenu" matTooltip="Cambiar estado">
              <mat-icon>swap_horiz</mat-icon>
            </button>
            <mat-menu #statusMenu="matMenu">
              @for (status of statuses; track status.id) {
                <button mat-menu-item (click)="changeStatus(ticket, status.id)"
                        [disabled]="ticket.status === status.id">
                  {{ status.name }}
                </button>
              }
            </mat-menu>
            <button mat-icon-button color="warn" matTooltip="Eliminar"
                    (click)="deleteTicket(ticket)">
              <mat-icon>delete</mat-icon>
            </button>
          }
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns(); sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns();" class="table-row"></tr>

      <!-- Sin resultados -->
      <tr class="no-data-row" *matNoDataRow>
        <td [attr.colspan]="displayedColumns().length">
          <div class="no-data">
            <mat-icon>inbox</mat-icon>
            <span>
              @if (tickets().length === 0) {
                Todavía no hay tickets. Levanta el primero con "Nuevo ticket".
              } @else {
                Ningún ticket coincide con el filtro.
              }
            </span>
          </div>
        </td>
      </tr>

    </table>
  </div>
</div>
